import { Config } from "../../../config/api.config";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface ResetPassword {
  token: string;
  newPassword: string;
  confirmPassword: string;
}

@Injectable({
  providedIn: "root",
})
export class ResetPasswordService {
  constructor(private http: HttpClient) {}

  resetPassword(payload: ResetPassword): Observable<void> {
    return this.http.post<void>(`${Config.webApiUrl}/v1/password/reset-password`, payload);
  }
}
